const AddressLocation = async ({
  // loader,
  google,
  location = { lat: 0, long: 0 },
  isAllResponse = false,
}) => {
  // const google = await loader.load();
  const geocoder = new google.maps.Geocoder();

  const latlng = {
    lat: location.lat,
    lng: location.long,
  };

  try {
    const response = await geocoder.geocode({ location: latlng });
    // console.log("response =>", response);

    if (isAllResponse) {
      return response;
    }

    if (response.results[0]) {
      const formatted_address = response.results[0];
      // console.log("formatted_address =>", formatted_address);
      return formatted_address;
    } else {
      // console.log("No results found");
      // window.alert("No results found");
      return {
        error: {
          message: `No results found`,
        },
      };
    }
  } catch (err) {
    // console.log("Geocoder error =>: ", err);
    return {
      error: {
        message: `Geocoder failed due to: ${err.message}`,
      },
    };
  }
};

export default AddressLocation;
